import React from 'react';
import chartNetEnergySimulation from 'src/assets/images/LandingPage/marketDesign/layerFour_simulation/chart-net-energy.png';

const ChartNetEnergySimulation = ({ className }: { className?: string }): JSX.Element => (
  <img src={chartNetEnergySimulation} className={className} />
);

export default ChartNetEnergySimulation;
